import * as z from 'zod';

export type FinnestMeta = {
  id: string;
  title: string;
  description: string;
  version: `v${number}`;
  examples?: z.$output[];
  deprecated?: boolean;
  deprecatedAt?: string;
  replacedBy?: string;
  regulatory?: 'ofb' | 'opin' | 'both' | 'none';
  piiFields?: string[];
};

export const finnest = z.registry<FinnestMeta>();
